/**
 * Settings: account details, and the connections that belong to them.
 *
 * "Meta Ads" used to be a top-level tab holding a single Connect button - a
 * one-time action given permanent real estate, and a second copy of the button
 * that already sits in the Overview integrations list. It is a connection, so
 * it lives with the other connections.
 *
 * @module web/screens/app/SettingsSection
 */
import { MetaScreen } from "./MetaScreen.tsx";
import { SettingsScreen } from "./SettingsScreen.tsx";
import { useBrand } from "../../state/BrandContext.tsx";
import { useEffect, useState } from "react";
import { TeamScreen } from "./TeamScreen.tsx";
import { AgentSection } from "./AgentSection.tsx";

type View = "brand" | "team" | "agents";
const viewFromHash = (h: string): View => h === "#settings/team" ? "team" : h.startsWith("#settings/agents") ? "agents" : "brand";

export function SettingsSection() {
  const { brand } = useBrand();
  const owner = (brand?.role ?? "owner") === "owner";
  const [view, setView] = useState<View>(() => viewFromHash(window.location.hash));
  useEffect(() => {
    const onHash = () => setView(viewFromHash(window.location.hash));
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  return (
    <>
      <div className="seg-bar"><div className="seg" role="tablist" aria-label="Settings view">
        <button className={`seg-btn${view === "brand" ? " on" : ""}`} role="tab" aria-selected={view === "brand"} onClick={() => { window.location.hash = "settings"; setView("brand"); }}>Brand & account</button>
        <button className={`seg-btn${view === "team" ? " on" : ""}`} role="tab" aria-selected={view === "team"} onClick={() => { window.location.hash = "settings/team"; setView("team"); }}>Team</button>
        <button className={`seg-btn${view === "agents" ? " on" : ""}`} role="tab" aria-selected={view === "agents"} onClick={() => { window.location.hash = "settings/agents"; setView("agents"); }}>Agents</button>
      </div></div>
      {view === "team" ? <TeamScreen /> : view === "agents" ? <AgentSection /> : <>
        <SettingsScreen />
        {owner && <><div className="rule" style={{ margin: "40px 0 18px" }}>Connections</div><MetaScreen /></>}
      </>}
    </>
  );
}
